import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_services';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private authService: AuthService
  ) {

  }//end cosnt

  ngOnInit() {
    this.authService.logout();
  }//end ngoninit

}//end class



